var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productData)?_c('v-row',{attrs:{"justify":"space-between"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.productData.clientImage),expression:"productData.clientImage"}],attrs:{"src":`${_vm.productData.clientImage}`,"height":"80","width":"200"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }